import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { CompaniesService } from "../companies/companies.service";
import { ApiService } from "../shared";
import { ProjectsService } from "../projects/projects.service";
import { ConfigService } from "../config.service";
import * as Joi from "joi";

@Injectable()
export class PostsService {
  static currentPost: any;
  private serviceUrl = ConfigService.serviceUrl;
  private postSchema: Joi.Schema = Joi.object().keys({
    type: Joi.string().min(1).required(),
    active: Joi.boolean(),
    context: Joi.object().required().keys({
      project_ids: Joi.array().required(),
      employer_ids: Joi.array().required(),
      nationalities: Joi.array().required(),
      countries: Joi.array().required(),
      program_id: Joi.string()
    }),
    data: Joi.object()
      .required()
      .keys({
        default_lang: Joi.string().min(1).required(),
        content: Joi.object()
          .required()
          .keys(
            ConfigService.languages.reduce((obj, curr) => {
              obj[curr.key] = Joi.alternatives().try(
                Joi.object().keys({
                  author: Joi.string().min(1).required(),
                  title: Joi.string().min(1).required(),
                  subtitle: Joi.string().min(1).required()
                }),
                Joi.object().keys({
                  author: Joi.string().min(1).required(),
                  title: Joi.string().min(1).required(),
                  post_summary: Joi.string().min(1).required(),
                  post_details: Joi.string().min(1).required()
                })
              );
              return obj;
            }, {})
          )
      }),
    id: Joi.string(),
    created_at: Joi.date(),
    updated_at: Joi.date(),
    author_id: Joi.string(),
    user_id: Joi.string(),
    company_id: Joi.string(),
    author_image: Joi.string(),
    author_type: Joi.string(),
    author: Joi.string()
  });

  constructor(
    private http: Http,
    private companiesService: CompaniesService,
    private apiService: ApiService,
    private projectsService: ProjectsService
  ) {}

  getPosts(): Observable<any[]> {
    return this.http
      .get(`${this.serviceUrl}/posts`)
      .map((res) => {
        return this.extractData(res, true);
      })
      .catch(this.handleError);
  }

  createPost(post: any): Observable<any> {
    return Observable.create((observer) => {
      Joi.validate(post, this.postSchema, (err, v) => {
        if (err) {
          observer.error(err);
          observer.complete();
        } else {
          this.http.post(`${this.serviceUrl}/posts`, post).subscribe(
            (resp) => {
              observer.next(this.extractData(resp, false));
              observer.complete();
            },
            (error) => {
              observer.error(this.handleError(error));
              observer.complete();
            }
          );
        }
      });
    });
  }

  editPost(post: any): Observable<any> {
    return Observable.create((observer) => {
      Joi.validate(post, this.postSchema, (err, v) => {
        if (err) {
          observer.error(err);
          observer.complete();
        } else {
          this.http.put(`${this.serviceUrl}/posts/` + post.id, post).subscribe(
            (resp) => {
              observer.next(this.extractData(resp, false));
              observer.complete();
            },
            (error) => {
              observer.error(this.handleError(error));
              observer.complete();
            }
          );
        }
      });
    });
  }

  deletePost(id: string) {
    return this.http.delete(`${this.serviceUrl}/posts/` + id).map(
      (resp) => {},
      (error) => {
        this.handleError(error);
      }
    );
  }

  getLanguages(): any[] {
    return ConfigService.languages;
  }

  getPostTypes(): any[] {
    return ConfigService.postTypes;
  }

  getProjects(): Observable<any> {
    return this.projectsService.getProjectList();
  }

  getNationalities(): any[] {
    return ConfigService.countryList;
  }

  getEmployers(): Observable<any> {
    return this.companiesService.getEmployers();
  }

  getProjectNames(posts: any[]) {
    this.projectsService.getProjectList().subscribe((projectList) => {
      posts.map((post) => {
        post.context.projectNames = [];
        if (post.context.project_ids.length < 1) {
          post.context.projectNames = ["<any>"];
        } else {
          post.context.project_ids.map((id) => {
            let projects = projectList.filter((it) => {
              return it.id === id;
            });
            if (projects.length > 0) {
              post.context.projectNames.push(projects[0].name);
            }
          });
        }
      });
      return posts;
    });
  }

  getCountryNames(ids: string[]): string[] {
    let names = ApiService.getCountryNames(ids);
    if (names.length > 0) {
      return names;
    }
    return ["<any>"];
  }

  getEmployerNames(posts: any[]) {
    this.companiesService.getEmployers().subscribe((employerList) => {
      posts.map((post) => {
        post.context.employerNames = [];
        if (post.context.employer_ids.length < 1) {
          post.context.employerNames = ["<any>"];
        } else {
          post.context.employer_ids.map((id) => {
            let employers = employerList.filter((it) => {
              return it.id === id;
            });
            if (employers.length > 0) {
              post.context.employerNames.push(employers[0].name);
            }
          });
        }
      });
      return posts;
    });
  }

  getItemsPerPageValues(): number[] {
    return ConfigService.itemsPerPageValues;
  }

  getItemsPerPage(): number {
    return ApiService.getItemsPerPage();
  }

  saveItemsPerPage(value: number) {
    ApiService.saveItemsPerPage(value);
  }

  private extractData(res: Response, getNames: boolean) {
    let body = res.json();
    if (getNames) {
      this.getProjectNames(body);
      this.getEmployerNames(body);
    }
    if (Array.isArray(body)) {
      body.forEach((it) => {
        it.context.countries = it.context.countries || [];
      });
    } else {
      body.context.countries = body.context.countries || [];
    }
    return body;
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/posts/posts.service.ts